import { classNames } from '@/lib/classNames';
import React from 'react';
import styles from './AuthDialogCard.scss';

type DivProps = JSX.IntrinsicElements['div'];

export const AuthDialogCard: React.FC<DivProps> = ({ children, className, ...props }) => {
  return (
    <div className={classNames(['auth-dialog-card', className])} {...props}>
      {children}
      <style jsx>{styles}</style>
    </div>
  );
};
